import { ValueError } from "../error/ValueError.js";
import { notOptional } from "./optional.js";
/** Is an unknown value a URL object? */
export function isURL(value) {
    return value instanceof URL;
}
/** Assert that an unknown value is a URL object. */
export function assertURL(value) {
    if (!isURL(value))
        throw new ValueError("Invalid URL", value);
}
/** Convert a possible URL to a URL or return `undefined` if conversion fails. */
export function getOptionalURL(possible, base = _BASE) {
    if (notOptional(possible)) {
        try {
            return isURL(possible) ? possible : new URL(possible, base);
        }
        catch (e) {
            //
        }
    }
}
const _BASE = typeof document === "object" ? document.baseURI : undefined;
/** Convert a possible URL to a URL but throw `ValueError` if conversion fails. */
export function getURL(possible, base) {
    const url = getOptionalURL(possible, base);
    if (!url)
        throw new ValueError("Invalid URL", possible);
    return url;
}
/** Just get the important part of a URL, e.g. `http://shax.com/test?uid=129483` → `shax.com/test` */
export function formatURL(possible, base) {
    const { host, pathname } = getURL(possible, base);
    return `${host}${pathname.length > 1 ? pathname : ""}`;
}
